export default {
    mlb: {
        awayTeam: {
            odds: {
                fullGame: {
                    moneyline: -200,
                    spread: -1.5,
                    spreadJuice: 0,
                },
                half: {
                    moneyline: -210,
                    spread: 0,
                    spreadJuice: -110,
                },
            },
            stats: {
                def: {
                    errors: 101,
                    fpct: 0.98,
                    ppg: 4.16,
                },
                off: {
                    avg: 0.252,
                    hr: 161,
                    obp: 0.324,
                    oppg: 4.96,
                    rbi: 635,
                    runs: 4.96,
                    slg: 0.425,
                },
                splits: {},
                pitching: {
                    bb: 489,
                    era: 3.67,
                    fip: 4,
                    homeruns: 558,
                    losses: 74,
                    saves: 63,
                    so: 136,
                    wins: 134,
                },
            },
            recordData: {
                record: '0-0',
                awayRecord: '0-0',
                homeRecord: '0-0',
                ou: '0-0',
                ats: '0-0',
            },
            sos: 5,
            injuries: [
                {
                    player: 'Luis Guerrero',
                    position: 'RP',
                    date: 'Sep 3',
                    status: '60-Day-IL',
                    desc: 'Aug 28: Guerrero (elbow) began a rehab assignment with High-A Greenville on Tuesday and worked around three walks and one hit in a scoreless inning in his first appearance.',
                    value: 0,
                },
                {
                    player: 'Nathaniel Lowe',
                    position: '1B',
                    date: 'Aug 31',
                    status: 'paternity',
                    desc: 'Aug 28: The Red Sox will place Lowe on the paternity list Thursday, Tim Healey of The Boston Globe reports.',
                    value: 0,
                },
                {
                    player: 'Wilyer Abreu',
                    position: 'RF',
                    date: 'Sep 5',
                    status: '10-Day-IL',
                    desc: 'Aug 27: Abreu (calf) ran sprints at 40-to-50 percent intensity Tuesday, MLB.com reports.',
                    value: 0,
                },
                {
                    player: 'Richard Fitts',
                    position: 'SP',
                    date: 'Sep 10',
                    status: '15-Day-IL',
                    desc: "Aug 26: The Red Sox will place Fitts (biceps) on the 15-day injured list prior to Tuesday's game in Baltimore, Chris Cotillo of MassLive.com reports.",
                    value: 0,
                },
                {
                    player: 'Marcelo Mayer',
                    position: '3B',
                    date: 'Feb 1',
                    status: '10-Day-IL',
                    desc: 'Aug 21: The Red Sox announced that Mayer underwent a successful right wrist arthroscopy Wednesday, Lauren Campbell of MassLive.com reports.',
                    value: 0,
                },
                {
                    player: 'Tanner Houck',
                    position: 'SP',
                    date: 'Sep 1',
                    status: '60-Day-IL',
                    desc: 'Aug 18: The Red Sox announced Monday that Houck (elbow) underwent a successful hybrid reconstruction of his right UCL with a flexor tendon repair, Chris Cotillo of MassLive.com reports.',
                    value: 0,
                },
                {
                    player: 'Hunter Dobbins',
                    position: 'SP',
                    date: 'Feb 1',
                    status: '60-Day-IL',
                    desc: 'Jul 31: The Red Sox placed Dobbins on the 15-day injured list Saturday with a torn ACL in his right knee.',
                    value: 0,
                },
                {
                    player: 'Patrick Sandoval',
                    position: 'SP',
                    date: 'Feb 1',
                    status: '60-Day-IL',
                    desc: 'Jul 25: Sandoval (elbow) has gone from throwing bullpen sessions to just playing catch and is doubtful to pitch this season, Chris Cotillo of MassLive.com reports.',
                    value: 0,
                },
                {
                    player: 'Josh Winckowski',
                    position: 'RP',
                    date: 'Sep 4',
                    status: '60-Day-IL',
                    desc: "Jul 17: Winckowski (elbow) is in the early stages of a throwing progression at the Red Sox' spring training complex in Florida, Chris Cotillo of MassLive.com reports.",
                    value: 0,
                },
                {
                    player: 'Liam Hendriks',
                    position: 'RP',
                    date: 'Sep 1',
                    status: '60-Day-IL',
                    desc: 'Jul 8: The Red Sox transferred Hendriks (hip) to the 60-day injured list Tuesday.',
                    value: 0,
                },
                {
                    player: 'Kutter Crawford',
                    position: 'SP',
                    date: 'Feb 1',
                    status: '60-Day-IL',
                    desc: 'Jul 7: The Red Sox announced that Crawford (knee) underwent successful surgery Thursday to reconstruct the stabilizing sheath of the extensor carpi ulnaris in his right wrist, MLB.com reports.',
                    value: 0,
                },
                {
                    player: 'Mark Kolozsvary',
                    position: 'C',
                    date: 'Feb 1',
                    status: 'Day-To-Day',
                    desc: 'Jun 18: Kolozsvary signed a minor-league contract with the Red Sox on Thursday that includes an invitation to spring training, Kiley McDaniel of ESPN.com reports.',
                    value: 0,
                },
                {
                    player: 'Triston Casas',
                    position: '1B',
                    date: 'Feb 1',
                    status: '60-Day-IL',
                    desc: 'Jun 3: Casas (knee) will be off crutches in two weeks and expects to be ready for Opening Day next season, Jen McCaffrey of The Athletic reports.',
                    value: 0,
                },
            ],
            teamName: 'Boston',
            teamId: 33,
            abbr: 'BOS',
            mascot: 'Red Sox',
            teamName: 'Boston Red Sox',
            shortName: '',
            pitcherData: 'https://www.espn.com/mlb/player/_/id/4297835',
            color: '#BD3039',
            pitcher: {
                firstName: 'Garrett',
                lastName: 'Crochet',
                stats: {
                    'Wins-Losses': 14,
                    'Earned Run Average': 2.38,
                    Strikeouts: 207,
                    'Walks Plus Hits Per Inning Pitched': 1.06,
                    xfip: 2.67,
                    kpercent: 31.2,
                    war: 5.3,
                    babip: 0.301,
                    bbpercent: 6.3,
                },
                throws: 'Left',
                splits: {
                    away: {
                        era: 2.43,
                        walks: 22,
                    },
                    home: {
                        era: 2.33,
                        walks: 20,
                    },
                },
            },
            openMoneyLine: -180,
            mlPercent: 82,
            spreadPercent: 88,
            mlMoneyPercent: 87,
            spreadMoneyPercent: 90,
            division: 'East',
            conference: 'American League',
        },
        homeTeam: {
            odds: {
                fullGame: {
                    moneyline: 170,
                    spread: 1.5,
                    spreadJuice: 0,
                },
                half: {
                    moneyline: 175,
                    spread: 0,
                    spreadJuice: 0,
                },
            },
            stats: {
                def: {
                    errors: 69,
                    fpct: 0.986,
                    ppg: 4.89,
                },
                off: {
                    avg: 0.24,
                    hr: 159,
                    obp: 0.305,
                    oppg: 4.3,
                    rbi: 541,
                    runs: 4.3,
                    slg: 0.402,
                },
                splits: {},
                pitching: {
                    bb: 611,
                    era: 4.68,
                    fip: 4.45,
                    homeruns: 651,
                    losses: 60,
                    saves: 46,
                    so: 181,
                    wins: 133,
                },
            },
            recordData: {
                record: '0-0',
                awayRecord: '0-0',
                homeRecord: '0-0',
                ou: '0-0',
                ats: '0-0',
            },
            sos: 21,
            injuries: [
                {
                    player: 'Tyler Wells',
                    position: 'SP',
                    date: 'Sep 2',
                    status: '60-Day-IL',
                    desc: 'Aug 27: Orioles interim manager Tony Mansolino said Wednesday that Wells (elbow) will be activated from the 60-day injured list next week and will be part of a six-man rotation for the remainder of the season, Andy Kostka of TheBaltimoreBanner.com reports.',
                    value: 0,
                },
                {
                    player: 'Brandon Young',
                    position: 'P',
                    date: 'Feb 1',
                    status: '60-Day-IL',
                    desc: 'Aug 27: The Orioles placed Young on the 15-day injured list Friday with a left hamstring strain.',
                    value: 0,
                },
                {
                    player: 'Scott Blewett',
                    position: 'RP',
                    date: 'Sep 15',
                    status: '60-Day-IL',
                    desc: 'Aug 26: The Orioles transferred Blewett (elbow) to the 60-day injured list Tuesday.',
                    value: 0,
                },
                {
                    player: 'Jorge Mateo',
                    position: 'SS',
                    date: 'Sep 1',
                    status: '60-Day-IL',
                    desc: 'Aug 25: Mateo (hamstring) appears on track to be activated from the 60-day injured list Sept. 1, Rich Dubroff of BaltimoreBaseball.com reports.',
                    value: 0,
                },
                {
                    player: 'Albert Suarez',
                    position: 'RP',
                    date: 'Aug 29',
                    status: '60-Day-IL',
                    desc: 'Aug 25: Suarez (shoulder) is expected to be limited to one inning in his next minor-league rehab appearance, Rich Dubroff of BaltimoreBaseball.com reports.',
                    value: 0,
                },
                {
                    player: 'Jordan Westburg',
                    position: '3B',
                    date: 'Sep 5',
                    status: '10-Day-IL',
                    desc: 'Aug 25: Orioles interim manager Tony Mansolino said Monday that Westburg (ankle) will not be ready for activation from the 10-day injured list when first eligible Friday, Danielle Allentuck of TheBaltimoreBanner.com reports.',
                    value: 0,
                },
                {
                    player: 'Cody Poteet',
                    position: 'RP',
                    date: 'Sep 9',
                    status: '60-Day-IL',
                    desc: 'Aug 23: Poteet (shoulder) is beginning a minor-league rehab assignment with Triple-A Norfolk on Saturday, Roch Kubatko of MASNSports.com reports.',
                    value: 0,
                },
                {
                    player: 'Gary Sanchez',
                    position: 'C',
                    date: 'Sep 6',
                    status: '60-Day-IL',
                    desc: 'Aug 22: The Orioles transferred Sanchez (knee) to the 60-day injured list Friday.',
                    value: 0,
                },
                {
                    player: 'Felix Bautista',
                    position: 'RP',
                    date: 'Feb 1',
                    status: '60-Day-IL',
                    desc: 'Aug 22: Bautista underwent surgery Tuesday to repair a torn labrum and torn rotator cuff in his right shoulder, and he is expected to be sidelined at least 12 months, Roch Kubatko of MASNSports.com reports.',
                    value: 0,
                },
                {
                    player: 'Adley Rutschman',
                    position: 'C',
                    date: 'Sep 1',
                    status: '10-Day-IL',
                    desc: 'Aug 21: The Orioles placed Rutschman on the 10-day injured list Thursday with a mild right oblique strain, Jake Rill of MLB.com reports.',
                    value: 0,
                },
                {
                    player: "Tyler O'Neill",
                    position: 'RF',
                    date: 'Sep 1',
                    status: '10-Day-IL',
                    desc: "Aug 18: O'Neill (wrist) resumed baseball activities Monday, Roch Kubatko of MASNSports.com reports.",
                    value: 0,
                },
                {
                    player: 'Zach Eflin',
                    position: 'SP',
                    date: 'Feb 1',
                    status: '60-Day-IL',
                    desc: 'Aug 18: The Orioles announced that Eflin underwent a lumbar microdiscectomy surgery Monday in Florida, Matt Weyrich of The Baltimore Sun reports.',
                    value: 0,
                },
                {
                    player: 'Grayson Rodriguez',
                    position: 'SP',
                    date: 'Feb 1',
                    status: '60-Day-IL',
                    desc: 'Aug 11: Rodriguez underwent a successful right elbow debridement to remove a bone spur Monday, Danielle Allentuck of TheBaltimoreBanner.com reports.',
                    value: 0,
                },
                {
                    player: 'Colin Selby',
                    position: 'RP',
                    date: 'Sep 1',
                    status: '15-Day-IL',
                    desc: 'Jul 29: The Orioles placed Selby on the 15-day injured list Tuesday due to a left hamstring strain.',
                    value: 0,
                },
                {
                    player: 'Rodolfo Martinez',
                    position: 'RP',
                    date: 'Aug 30',
                    status: 'Day-To-Day',
                    desc: 'May 30: The Orioles signed Martinez to a minor-league contract Nov. 1 that includes an invitation to spring training.',
                    value: 0,
                },
                {
                    player: 'Carlos Tavera',
                    position: 'RP',
                    date: 'Sep 2',
                    status: 'Day-To-Day',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Justin Armbruester',
                    position: 'SP',
                    date: 'Sep 1',
                    status: 'Day-To-Day',
                    desc: 'Apr 25: Armbruester underwent right lat surgery Friday, Andy Kostka of TheBaltimoreBanner.com reports.',
                    value: 0,
                },
                {
                    player: 'Franklin Barreto',
                    position: 'LF',
                    date: 'Aug 31',
                    status: 'Day-To-Day',
                    desc: 'Mar 30: The Orioles reassigned Barreto to minor-league camp Monday, Jake Rill of MLB.com reports.',
                    value: 0,
                },
            ],
            teamName: 'Baltimore',
            teamId: 7654,
            abbr: 'BAL',
            mascot: 'Orioles',
            teamName: 'Baltimore Orioles',
            shortName: '',
            pitcherData: 'https://www.espn.com/mlb/player/_/id/5085743',
            color: '#DF4601',
            pitcher: {
                firstName: 'Cade',
                lastName: 'Povich',
                stats: {
                    'Wins-Losses': 2,
                    'Earned Run Average': 5.13,
                    Strikeouts: 95,
                    'Walks Plus Hits Per Inning Pitched': 1.43,
                    xfip: 3.86,
                    kpercent: 25.4,
                    war: 1.3,
                    babip: 0.335,
                    bbpercent: 8.6,
                },
                throws: 'Left',
                splits: {
                    away: {
                        era: 3.86,
                        walks: 9,
                    },
                    home: {
                        era: 6.22,
                        walks: 23,
                    },
                },
            },
            openMoneyLine: 150,
            mlPercent: 18,
            spreadPercent: 12,
            mlMoneyPercent: 13,
            spreadMoneyPercent: 10,
            division: 'East',
            conference: 'American League',
        },
        prediction: {
            awayScore: 5.26,
            homeScore: 2.88,
            winner: 33,
            spreadWinner: 33,
            powerSpread: 2.38,
            powerMoneyline: {
                dogML: 169,
                favML: -189,
            },
            powerLineWinner: 7654,
            confidence: 0.7491028904914856,
        },
        status: 'not started',
        total: 8,
        advantages: [
            {
                adv: 'Key Factor - PPG',
                id: 'key-factor',
                factorId: 'oppg',
                winPercent: 52.23097112860893,
                teamId: 33,
                description: 'BOS has a better PPG (off). Teams with a better PPG win against the moneyline at a 52.23% rate.',
                amount: 0.6600000000000001,
            },
            {
                adv: 'Key Factor - PPG',
                id: 'key-factor',
                factorId: 'ppg',
                winPercent: 51.82331792501284,
                teamId: 33,
                description: 'BOS has a better PPG (def).  Teams with a better PPG win against the moneyline at a 51.82% rate.',
                amount: 0.7299999999999995,
            },
            {
                adv: 'Key Factor - AVG',
                id: 'key-factor',
                factorId: 'avg',
                winPercent: 53.83403361344538,
                teamId: 33,
                description: 'BOS has a better AVG (off). Teams with a better AVG win against the moneyline at a 53.83% rate.',
                amount: 0.01200000000000001,
            },
            {
                adv: 'Key Factor - HRs',
                id: 'key-factor',
                factorId: 'hr',
                winPercent: 51.347068145800314,
                teamId: 33,
                description: 'BOS has a better HRs (off). Teams with a better HRs win against the moneyline at a 51.35% rate.',
                amount: 2,
            },
            {
                adv: 'Key Factor - OBP',
                id: 'key-factor',
                factorId: 'obp',
                winPercent: 53.305570015616865,
                teamId: 33,
                description: 'BOS has a better OBP (off). Teams with a better OBP win against the moneyline at a 53.31% rate.',
                amount: 0.019000000000000017,
            },
            {
                adv: 'Key Factor - RBI(s)',
                id: 'key-factor',
                factorId: 'rbi',
                winPercent: 52.892561983471076,
                teamId: 33,
                description: 'BOS has a better RBI(s) (off). Teams with a better RBI(s) win against the moneyline at a 52.89% rate.',
                amount: 94,
            },
            {
                adv: 'Key Factor - SLG',
                id: 'key-factor',
                factorId: 'slg',
                winPercent: 51.622874806800624,
                teamId: 33,
                description: 'BOS has a better SLG (off). Teams with a better SLG win against the moneyline at a 51.62% rate.',
                amount: 0.022999999999999965,
            },
            {
                adv: 'Key Factor - ERs',
                id: 'key-factor',
                factorId: 'errors',
                winPercent: 52.66594124047879,
                teamId: 7654,
                description: 'BAL has a better ERs (def).  Teams with a better ERs win against the moneyline at a 52.67% rate.',
                amount: 32,
            },
            {
                adv: 'Key Factor - FPCT',
                id: 'key-factor',
                factorId: 'fpct',
                winPercent: 52.7887323943662,
                teamId: 7654,
                description: 'BAL has a better FPCT (def). Teams with a better FPCT win against the moneyline at a 52.79% rate.',
                amount: 0.006000000000000005,
            },
            {
                adv: 'Key Factor - ERA',
                id: 'key-factor',
                factorId: 'Earned Run Average',
                winPercent: 52.46913580246913,
                teamId: 33,
                description: 'BOS has a better ERA (pitcher).  Teams with a better ERA win against the moneyline at a 52.47% rate.',
                amount: 2.75,
            },
            {
                adv: 'Key Factor - WHIP',
                id: 'key-factor',
                factorId: 'Walks Plus Hits Per Inning Pitched',
                winPercent: 51.44478844169247,
                teamId: 33,
                description: 'BOS has a better WHIP (pitcher).  Teams with a better WHIP win against the moneyline at a 51.44% rate.',
                amount: 0.3699999999999999,
            },
            {
                adv: 'Key Factor - Ks',
                id: 'key-factor',
                factorId: 'Strikeouts',
                winPercent: 51.04384133611691,
                teamId: 33,
                description: 'BOS has a better Ks (pitcher). Teams with a better Ks win against the moneyline at a 51.04% rate.',
                amount: 112,
            },
            {
                adv: 'Key Factor - BABIP',
                id: 'key-factor',
                factorId: 'babip',
                winPercent: 51.26436781609195,
                teamId: 33,
                description: 'BOS has a better BABIP (pitcher).  Teams with a better BABIP win against the moneyline at a 51.26% rate.',
                amount: 0.03400000000000003,
            },
            {
                adv: 'Key Factor - K%',
                id: 'key-factor',
                factorId: 'kpercent',
                winPercent: 52.432741843159704,
                teamId: 33,
                description: 'BOS has a better K% (pitcher). Teams with a better K% win against the moneyline at a 52.43% rate.',
                amount: 5.800000000000001,
            },
            {
                adv: 'Key Factor - BB%',
                id: 'key-factor',
                factorId: 'bbpercent',
                winPercent: 51.41864504921829,
                teamId: 33,
                description: 'BOS has a better BB% (pitcher).  Teams with a better BB% win against the moneyline at a 51.42% rate.',
                amount: 2.3,
            },
            {
                adv: 'Key Factor - WAR',
                id: 'key-factor',
                factorId: 'war',
                winPercent: 50.778443113772454,
                teamId: 33,
                description: 'BOS has a better WAR (pitcher). Teams with a better WAR win against the moneyline at a 50.78% rate.',
                amount: 4,
            },
            {
                adv: 'Key Factor - xFIP',
                id: 'key-factor',
                factorId: 'xfip',
                winPercent: 53.00859598853869,
                teamId: 33,
                description: 'BOS has a better xFIP (pitcher).  Teams with a better xFIP win against the moneyline at a 53.01% rate.',
                amount: 1.19,
            },
            {
                adv: 'Key Factor - Saves',
                id: 'key-factor',
                factorId: 'saves',
                winPercent: 50.684181718664476,
                teamId: 33,
                description: 'BOS has a better Saves (pitching). Teams with a better Saves win against the moneyline at a 50.68% rate.',
                amount: 17,
            },
            {
                adv: 'Key Factor - Ks',
                id: 'key-factor',
                factorId: 'so',
                winPercent: 50.208333333333336,
                teamId: 7654,
                description: 'BAL has a better Ks (pitching). Teams with a better Ks win against the moneyline at a 50.21% rate.',
                amount: 45,
            },
            {
                adv: 'Key Factor - ERA',
                id: 'key-factor',
                factorId: 'era',
                winPercent: 51.99590583418628,
                teamId: 33,
                description: 'BOS has a better ERA (pitching).  Teams with a better ERA win against the moneyline at a 52.00% rate.',
                amount: 1.0099999999999998,
            },
            {
                adv: 'Key Factor - FIP',
                id: 'key-factor',
                factorId: 'fip',
                winPercent: 51.660735468564646,
                teamId: 33,
                description: 'BOS has a better FIP (pitching).  Teams with a better FIP win against the moneyline at a 51.66% rate.',
                amount: 0.4500000000000002,
            },
            {
                adv: 'Key Factor - Walks',
                id: 'key-factor',
                factorId: 'bb',
                winPercent: 51.57135497166409,
                teamId: 33,
                description: 'BOS has a better Walks (pitching).  Teams with a better Walks win against the moneyline at a 51.57% rate.',
                amount: 122,
            },
            {
                adv: 'Key Factor - HRs',
                id: 'key-factor',
                factorId: 'homeruns',
                winPercent: 52.31719876416066,
                teamId: 33,
                description: 'BOS has a better HRs (pitching).  Teams with a better HRs win against the moneyline at a 52.32% rate.',
                amount: 93,
            },
            {
                adv: 'Power Rank',
                id: 'power-rank',
                description: 'BAL has an advantage based on our power rank data.',
                teamId: 7654,
            },
        ],
        trends: [
            {
                id: 'team-days-of-week',
                label: 'Boston Win % on Thursday',
                teamId: 33,
                description: 'Boston win 75.00% of games on Thu.',
                type: 'team',
                query: false,
            },
            {
                id: 'days-of-week',
                label: 'Dogs Win % on Thursday',
                teamId: 33,
                description: 'Dogs are 45.71% on the moneyline on Thursday.',
                type: 'team',
                query: false,
            },
            {
                id: 'days-of-week',
                label: 'Dogs Cover % on Thursday',
                teamId: 33,
                description: 'Dogs are 62.29% against the spread on Thursday.',
                type: 'team',
                query: false,
            },
            {
                id: 'random-trend-publicMoneySpread-divisionGame-afterLateGame',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    publicMoneySpread: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'More Public Money (spread)',
                        id: 'publicMoneySpread',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have more public money on the spread.',
                        sports: ['all'],
                        disabledBy: [],
                        sidePreference: 'away',
                    },
                    divisionGame: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'game',
                        label: 'Division Game',
                        id: 'divisionGame',
                        type: 'boolean',
                        value: true,
                        description: 'Filter games that are division matchups.',
                        sport: ['mlb', 'nfl', 'nba', 'nhl'],
                        disabledBy: [],
                    },
                    afterLateGame: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'game',
                        label: 'After a Late Game',
                        id: 'afterLateGame',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will be coming off a late game. A late game is defined as a game that starts after 8pm local time.',
                        sports: ['all'],
                        disabledBy: [],
                    },
                },
                description: 'getting more public money on the spread, playing a division game, coming off a late game.',
                type: 'team',
                query: true,
                teamId: 33,
            },
            {
                id: 'random-trend-publicMoneySpread-publicMoney-awayTeam',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    publicMoneySpread: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'More Public Money (spread)',
                        id: 'publicMoneySpread',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have more public money on the spread.',
                        sports: ['all'],
                        disabledBy: [],
                        sidePreference: 'away',
                    },
                    publicMoney: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'More Public Money (moneyline)',
                        id: 'publicMoney',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have more public money on the moneyline.',
                        sports: ['all'],
                        disabledBy: [],
                    },
                    awayTeam: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Away Team',
                        id: 'awayTeam',
                        type: 'boolean',
                        disabledBy: ['backHome', 'homeTeam'],
                        value: true,
                        description: 'Filter games where the matched team is the away team.',
                        sports: ['all'],
                    },
                },
                description: 'getting more public money on the spread, getting more public money on the moneyline, the away team.',
                type: 'team',
                query: true,
                teamId: 33,
            },
            {
                id: 'random-trend-lineMovementFavored-afterLateGame-awayTeam',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    lineMovementFavored: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Line Movement Favored',
                        id: 'lineMovementFavored',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team is more favored by the current line than the opening line.',
                        sports: ['all'],
                        disabledBy: [],
                        sidePreference: 'away',
                    },
                    afterLateGame: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'game',
                        label: 'After a Late Game',
                        id: 'afterLateGame',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will be coming off a late game. A late game is defined as a game that starts after 8pm local time.',
                        sports: ['all'],
                        disabledBy: [],
                    },
                    awayTeam: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Away Team',
                        id: 'awayTeam',
                        type: 'boolean',
                        disabledBy: ['backHome', 'homeTeam'],
                        value: true,
                        description: 'Filter games where the matched team is the away team.',
                        sports: ['all'],
                    },
                },
                description: 'with the current line favoring them more than the opener, coming off a late game, the away team.',
                type: 'team',
                query: true,
                teamId: 33,
            },
            {
                id: 'team-days-of-week',
                label: 'Baltimore Win % on Thursday',
                teamId: 7654,
                description: 'Baltimore win 75.00% of games on Thu.',
                type: 'team',
                query: false,
            },
            {
                id: 'days-of-week',
                label: 'Favorites Win % on Thursday',
                teamId: 7654,
                description: 'Favorites are 54.29% on the moneyline on Thursday.',
                type: 'team',
                query: false,
            },
            {
                id: 'days-of-week',
                label: 'Favorites Cover % on Thursday',
                teamId: 7654,
                description: 'Favorites are 37.71% against the spread on Thursday.',
                type: 'team',
                query: false,
            },
            {
                id: 'random-trend-conferenceGame-publicMoneySpread-lessPublicMoney',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: false,
                filters: {
                    conferenceGame: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'game',
                        label: 'Conference Game',
                        id: 'conferenceGame',
                        type: 'boolean',
                        value: true,
                        description: 'Filter games that are conference matchups.',
                        sport: ['mlb', 'nfl', 'nba', 'nhl'],
                        disabledBy: [],
                        sidePreference: 'both',
                    },
                    publicMoneySpread: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'More Public Money (spread)',
                        id: 'publicMoneySpread',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have more public money on the spread.',
                        sports: ['all'],
                        disabledBy: [],
                        sidePreference: 'away',
                    },
                    lessPublicMoney: {
                        homeMatched: true,
                        awayMatched: false,
                        category: 'general',
                        label: 'Less Public Money (moneyline)',
                        id: 'lessPublicMoney',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have less public money on the moneyline.',
                        sports: ['all'],
                        disabledBy: [],
                    },
                },
                description: 'playing a conference game, getting more public money on the spread, getting less public money on the moneyline.',
                type: 'team',
                query: true,
                teamId: 7654,
            },
            {
                id: 'random-trend-conferenceGame-afterLateGame-offAWin',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    conferenceGame: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'game',
                        label: 'Conference Game',
                        id: 'conferenceGame',
                        type: 'boolean',
                        value: true,
                        description: 'Filter games that are conference matchups.',
                        sport: ['mlb', 'nfl', 'nba', 'nhl'],
                        disabledBy: [],
                        sidePreference: 'both',
                    },
                    afterLateGame: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'game',
                        label: 'After a Late Game',
                        id: 'afterLateGame',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will be coming off a late game. A late game is defined as a game that starts after 8pm local time.',
                        sports: ['all'],
                        disabledBy: [],
                    },
                    offAWin: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Off A Win',
                        id: 'offAWin',
                        type: 'boolean',
                        disabledBy: ['afterBeingShutout', 'offALoss'],
                        value: true,
                        description: 'The matched team is coming off a win.',
                        sports: ['all'],
                    },
                },
                description: 'playing a conference game, coming off a late game.',
                type: 'team',
                query: true,
                teamId: 33,
            },
        ],
        bookData: {
            moneylines: [
                {
                    awayLine: -210,
                    homeLine: 170,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: -204,
                    homeLine: 167,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: -200,
                    homeLine: 168,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
            spreads: [
                {
                    awayLine: -1.5,
                    homeLine: 1.5,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: -1.5,
                    homeLine: 1.5,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: -1.5,
                    homeLine: 1.5,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
        },
        openingSpread: 1.5,
        gameId: '2025-08-28T17:05:00.000Z-7654-33',
        dateTime: '2025-08-28T17:05:00.000Z',
        totalStats: {
            total: 8,
            over: 177,
            under: 168,
        },
    },
    nba: {
        awayTeam: {
            odds: {
                fullGame: {
                    moneyline: 165,
                    spread: 4.5,
                    spreadJuice: 0,
                },
                half: {
                    moneyline: 140,
                    spread: 0,
                    spreadJuice: -110,
                },
            },
            stats: {
                def: {
                    defEff: 1.105,
                    fouls: 23,
                    oppThreePoint: 35.8,
                    ppg: 114,
                    reboundPercent: 51,
                },
                off: {
                    astTo: 1.588,
                    floorPercent: 50.5,
                    freeThrow: 79.9,
                    offEff: 1.131,
                    oppg: 116.7,
                    paceofplay: 21,
                    threePoint: 37.4,
                },
                splits: {},
            },
            recordData: {
                record: '0-0',
                awayRecord: '0-0',
                homeRecord: '0-0',
                ou: '0-0',
                ats: '0-0',
            },
            sos: 12,
            injuries: [
                {
                    player: 'Isaiah Livers',
                    position: 'F',
                    date: 'Dec 5',
                    status: 'Out',
                    desc: "Nov 30: Livers (hip) has been ruled out for Monday's game against the Lakers, Duane Rankin of The Arizona Republic reports.",
                    value: 0,
                },
                {
                    player: 'Ryan Dunn',
                    position: 'F',
                    date: 'Dec 1',
                    status: 'Out',
                    desc: "Nov 30: Dunn (wrist) is probable for Monday's game against the Lakers.",
                    value: 0,
                },
                {
                    player: 'Jalen Green',
                    position: 'G',
                    date: 'Dec 18',
                    status: 'Out',
                    desc: 'Nov 11: Green (hamstring) will be re-evaluated in four-to-six weeks, Shams Charania of ESPN reports.',
                    value: 0,
                },
            ],
            teamName: 'Phoenix',
            teamId: 234345,
            abbr: 'PHO',
            mascot: 'Suns',
            shortName: 'PHX',
            pitcherData: '',
            color: '#1D1160',
            openMoneyLine: 195,
            mlPercent: 8,
            spreadPercent: 39,
            mlMoneyPercent: 5,
            spreadMoneyPercent: 58,
            division: 'Pacific',
            conference: 'Western Conference',
        },
        homeTeam: {
            odds: {
                fullGame: {
                    moneyline: -195,
                    spread: -4.5,
                    spreadJuice: 0,
                },
                half: {
                    moneyline: -165,
                    spread: 0,
                    spreadJuice: 0,
                },
            },
            stats: {
                def: {
                    defEff: 1.124,
                    fouls: 19.8,
                    oppThreePoint: 36.6,
                    ppg: 115.4,
                    reboundPercent: 51.8,
                },
                off: {
                    astTo: 1.672,
                    floorPercent: 54.2,
                    freeThrow: 79.8,
                    offEff: 1.165,
                    oppg: 119.6,
                    paceofplay: 25,
                    threePoint: 35,
                },
                splits: {},
            },
            recordData: {
                record: '0-0',
                awayRecord: '0-0',
                homeRecord: '0-0',
                ou: '0-0',
                ats: '0-0',
            },
            sos: 8,
            injuries: [
                {
                    player: 'Marcus Smart',
                    position: 'G',
                    date: 'Dec 1',
                    status: 'Day-To-Day',
                    desc: "Dec 1: Smart (back) has been ruled out for Sunday's game against the Pelicans, Thuc Nhi Nguyen of the Los Angeles Times reports.",
                    value: 0,
                },
                {
                    player: 'LeBron James',
                    position: 'F',
                    date: 'Dec 1',
                    status: 'Day-To-Day',
                    desc: "Dec 1: James (foot) has been ruled out for Sunday's game against the Pelicans, Dave McMenamin of ESPN.com reports.",
                    value: 0,
                },
                {
                    player: 'Deandre Ayton',
                    position: 'C',
                    date: 'Dec 1',
                    status: 'Day-To-Day',
                    desc: "Dec 1: Ayton exited Sunday's game and did not return due to right knee soreness, Law Murray of The Athletic reports.",
                    value: 0,
                },
            ],
            teamName: 'Los Angeles',
            teamId: 8922,
            abbr: 'LAL',
            mascot: 'Lakers',
            shortName: 'LA Lakers',
            pitcherData: '',
            color: '#552583',
            openMoneyLine: -245,
            mlPercent: 92,
            spreadPercent: 61,
            mlMoneyPercent: 95,
            spreadMoneyPercent: 42,
            division: 'Pacific',
            conference: 'Western Conference',
        },
        prediction: {
            awayScore: 116.6,
            homeScore: 122.44,
            winner: 8922,
            spreadWinner: 8922,
            powerSpread: 5.840000000000003,
            powerMoneyline: {
                dogML: 150,
                favML: -160,
            },
            powerLineWinner: 234345,
            confidence: 0.3372496302720713,
        },
        status: 'not started',
        total: 234.5,
        advantages: [
            {
                adv: 'Key Factor - Floor',
                id: 'key-factor',
                factorId: 'floorPercent',
                winPercent: 55.47703180212014,
                teamId: 8922,
                description: 'LAL has a better Floor (off). Teams with a better Floor win against the spread at a 55.48% rate.',
                amount: 3.700000000000003,
            },
            {
                adv: 'Key Factor - 3 Point',
                id: 'key-factor',
                factorId: 'threePoint',
                winPercent: 49.122807017543856,
                teamId: 234345,
                description: 'PHO has a better 3 Point (off). Teams with a better 3 Point win against the spread at a 49.12% rate.',
                amount: 2.3999999999999986,
            },
            {
                adv: 'Key Factor - FT',
                id: 'key-factor',
                factorId: 'freeThrow',
                winPercent: 52.4822695035461,
                teamId: 234345,
                description: 'PHO has a better FT (off). Teams with a better FT win against the spread at a 52.48% rate.',
                amount: 0.10000000000000853,
            },
            {
                adv: 'Key Factor - AST:TO',
                id: 'key-factor',
                factorId: 'astTo',
                winPercent: 52.65017667844523,
                teamId: 8922,
                description: 'LAL has a better AST:TO (off). Teams with a better AST:TO win against the spread at a 52.65% rate.',
                amount: 0.08399999999999985,
            },
            {
                adv: 'Key Factor - PPG',
                id: 'key-factor',
                factorId: 'oppg',
                winPercent: 50.36496350364964,
                teamId: 8922,
                description: 'LAL has a better PPG (off). Teams with a better PPG win against the spread at a 50.36% rate.',
                amount: 2.8999999999999915,
            },
            {
                adv: 'Key Factor - Eff%',
                id: 'key-factor',
                factorId: 'offEff',
                winPercent: 54.60992907801418,
                teamId: 8922,
                description: 'LAL has a better Eff% (off). Teams with a better Eff% win against the spread at a 54.61% rate.',
                amount: 0.03400000000000003,
            },
            {
                adv: 'Key Factor - Rebound',
                id: 'key-factor',
                factorId: 'reboundPercent',
                winPercent: 50.54945054945055,
                teamId: 8922,
                description: 'LAL has a better Rebound (def). Teams with a better Rebound win against the spread at a 50.55% rate.',
                amount: 0.7999999999999972,
            },
            {
                adv: 'Key Factor - PPG',
                id: 'key-factor',
                factorId: 'ppg',
                winPercent: 51.40845070422535,
                teamId: 234345,
                description: 'PHO has a better PPG (def).  Teams with a better PPG win against the spread at a 51.41% rate.',
                amount: 1.4000000000000057,
            },
            {
                adv: 'Key Factor - Eff%',
                id: 'key-factor',
                factorId: 'defEff',
                winPercent: 49.647887323943664,
                teamId: 8922,
                description: 'LAL has a better Eff% (def). Teams with a better Eff% win against the spread at a 49.65% rate.',
                amount: 0.019000000000000128,
            },
            {
                adv: 'Key Factor - Fouls PG',
                id: 'key-factor',
                factorId: 'fouls',
                winPercent: 48.669201520912544,
                teamId: 8922,
                description: 'LAL has a better Fouls PG (def).  Teams with a better Fouls PG win against the spread at a 48.67% rate.',
                amount: 3.1999999999999993,
            },
            {
                adv: 'Key Factor - 3 Point',
                id: 'key-factor',
                factorId: 'oppThreePoint',
                winPercent: 47.01754385964912,
                teamId: 234345,
                description: 'PHO has a better 3 Point (def).  Teams with a better 3 Point win against the spread at a 47.02% rate.',
                amount: 0.8000000000000043,
            },
            {
                adv: 'Power Rank',
                id: 'power-rank',
                description: 'PHO has an advantage based on our power rank data.',
                teamId: 234345,
            },
        ],
        trends: [
            {
                id: 'team-days-of-week',
                label: 'Phoenix Win % on Monday',
                teamId: 234345,
                description: 'Phoenix win 33.33% of games on Monday.',
                type: 'team',
                query: false,
            },
            {
                id: 'days-of-week',
                label: 'Dogs Win % on Monday',
                teamId: 234345,
                description: 'Dogs are 25.53% on the moneyline on Monday.',
                type: 'team',
                query: false,
            },
            {
                id: 'days-of-week',
                label: 'Dogs Cover % on Monday',
                teamId: 234345,
                description: 'Dogs are 55.32% against the spread on Monday.',
                type: 'team',
                query: false,
            },
            {
                id: 'random-trend-publicMoney-divisionGame-predictedWinner',
                label: 'ProphetAI Trend',
                homeMatch: true,
                awayMatch: false,
                filters: {
                    publicMoney: {
                        homeMatched: true,
                        awayMatched: false,
                        category: 'general',
                        label: 'More Public Money (moneyline)',
                        id: 'publicMoney',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have more public money on the moneyline.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'home',
                    },
                    divisionGame: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'game',
                        label: 'Division Game',
                        id: 'divisionGame',
                        type: 'boolean',
                        value: true,
                        description: 'Filter games that are division matchups.',
                        sport: ['mlb', 'nfl', 'nba', 'nhl'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                    },
                    predictedWinner: {
                        homeMatched: true,
                        awayMatched: false,
                        category: 'prophetAI',
                        label: 'Predicted Winner',
                        id: 'predictedWinner',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will be the team prophetAI has winning the game.',
                        sports: ['all'],
                        disabledBy: ['powerSpreadWinner'],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                    },
                },
                description: 'getting more public money on the moneyline, playing a division game, picked to win by ProphetAI.',
                type: 'team',
                query: true,
                teamId: 8922,
            },
            {
                id: 'random-trend-awayTeam-highTotalPoints-offALoss',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    awayTeam: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Away Team',
                        id: 'awayTeam',
                        type: 'boolean',
                        disabledBy: ['backHome', 'homeTeam'],
                        value: true,
                        description: 'Filter games where the matched team is the away team.',
                        sports: ['all'],
                        filterTargets: ['away'],
                        requiresLastGame: false,
                        sidePreference: 'away',
                    },
                    highTotalPoints: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'prophetAI',
                        label: 'High Total Projected Points',
                        id: 'highTotalPoints',
                        type: 'boolean',
                        value: true,
                        description: 'Filter games where the projected total points exceed the sport-specific threshold',
                        sports: ['nfl', 'nba', 'cfb', 'nhl', 'cbb', 'mlb'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'both',
                    },
                    offALoss: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Off A Loss',
                        id: 'offALoss',
                        type: 'boolean',
                        disabledBy: ['winStreak', 'afterBlowoutWin', 'offAWin'],
                        value: true,
                        description: 'The matched team is coming off a loss.',
                        sports: ['all'],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: true,
                        sidePreference: 'away',
                    },
                },
                description: 'the away team, in a high total projected points game, coming off a loss.',
                type: 'team',
                query: true,
                teamId: 234345,
            },
            {
                id: 'random-trend-offALoss-afterLateGame-highTotalPoints',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    offALoss: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Off A Loss',
                        id: 'offALoss',
                        type: 'boolean',
                        disabledBy: ['winStreak', 'afterBlowoutWin', 'offAWin'],
                        value: true,
                        description: 'The matched team is coming off a loss.',
                        sports: ['all'],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: true,
                        sidePreference: 'away',
                    },
                    afterLateGame: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'game',
                        label: 'After a Late Game',
                        id: 'afterLateGame',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will be coming off a late game. A late game is defined as a game that starts after 7pm local time.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: true,
                    },
                    highTotalPoints: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'prophetAI',
                        label: 'High Total Projected Points',
                        id: 'highTotalPoints',
                        type: 'boolean',
                        value: true,
                        description: 'Filter games where the projected total points exceed the sport-specific threshold',
                        sports: ['nfl', 'nba', 'cfb', 'nhl', 'cbb', 'mlb'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'both',
                    },
                },
                description: 'coming off a loss, coming off a late game, in a high total projected points game.',
                type: 'team',
                query: true,
                teamId: 234345,
            },
            {
                id: 'team-days-of-week',
                label: 'Los Angeles Win % on Monday',
                teamId: 8922,
                description: 'Los Angeles win 33.33% of games on Monday.',
                type: 'team',
                query: false,
            },
            {
                id: 'days-of-week',
                label: 'Favorites Win % on Monday',
                teamId: 8922,
                description: 'Favorites are 74.47% on the moneyline on Monday.',
                type: 'team',
                query: false,
            },
            {
                id: 'days-of-week',
                label: 'Favorites Cover % on Monday',
                teamId: 8922,
                description: 'Favorites are 44.68% against the spread on Monday.',
                type: 'team',
                query: false,
            },
            {
                id: 'random-trend-highTotalPoints-publicMoney-lineMovementFavored',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: false,
                filters: {
                    highTotalPoints: {
                        homeMatched: true,
                        awayMatched: true,
                        category: 'prophetAI',
                        label: 'High Total Projected Points',
                        id: 'highTotalPoints',
                        type: 'boolean',
                        value: true,
                        description: 'Filter games where the projected total points exceed the sport-specific threshold',
                        sports: ['nfl', 'nba', 'cfb', 'nhl', 'cbb', 'mlb'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'both',
                    },
                    publicMoney: {
                        homeMatched: true,
                        awayMatched: false,
                        category: 'general',
                        label: 'More Public Money (moneyline)',
                        id: 'publicMoney',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have more public money on the moneyline.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'home',
                    },
                    lineMovementFavored: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Line Movement Favored',
                        id: 'lineMovementFavored',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team is more favored by the current line than the opening line.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'away',
                    },
                },
                description:
                    'in a high total projected points game, getting more public money on the moneyline, with the current line favoring them more than the opener.',
                type: 'team',
                query: true,
                teamId: 8922,
            },
            {
                id: 'random-trend-lessPublicMoney-lessPublicBetsSpread-publicMoneySpread',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    lessPublicMoney: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'Less Public Money (moneyline)',
                        id: 'lessPublicMoney',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have less public money on the moneyline.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'away',
                    },
                    lessPublicBetsSpread: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'Less Public Bets (spread)',
                        id: 'lessPublicBetsSpread',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have less public bets on the spread.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                    },
                    publicMoneySpread: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'More Public Money (spread)',
                        id: 'publicMoneySpread',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have more public money on the spread.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'away',
                    },
                },
                description: 'getting less public money on the moneyline, getting less public bets on the spread, getting more public money on the spread.',
                type: 'team',
                query: true,
                teamId: 234345,
            },
            {
                id: 'random-trend-publicMoneySpread-offALoss-awayTeam',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    publicMoneySpread: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'More Public Money (spread)',
                        id: 'publicMoneySpread',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have more public money on the spread.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'away',
                    },
                    offALoss: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Off A Loss',
                        id: 'offALoss',
                        type: 'boolean',
                        disabledBy: ['winStreak', 'afterBlowoutWin', 'offAWin'],
                        value: true,
                        description: 'The matched team is coming off a loss.',
                        sports: ['all'],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: true,
                        sidePreference: 'away',
                    },
                    awayTeam: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Away Team',
                        id: 'awayTeam',
                        type: 'boolean',
                        disabledBy: ['backHome', 'homeTeam'],
                        value: true,
                        description: 'Filter games where the matched team is the away team.',
                        sports: ['all'],
                        filterTargets: ['away'],
                        requiresLastGame: false,
                        sidePreference: 'away',
                    },
                },
                description: 'getting more public money on the spread, coming off a loss, the away team.',
                type: 'team',
                query: true,
                teamId: 234345,
            },
            {
                id: 'random-trend-lineMovementFavored-offALoss-lessPublicBetsSpread',
                label: 'ProphetAI Trend',
                homeMatch: false,
                awayMatch: true,
                filters: {
                    lineMovementFavored: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Line Movement Favored',
                        id: 'lineMovementFavored',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team is more favored by the current line than the opening line.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                        sidePreference: 'away',
                    },
                    offALoss: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'team',
                        label: 'Off A Loss',
                        id: 'offALoss',
                        type: 'boolean',
                        disabledBy: ['winStreak', 'afterBlowoutWin', 'offAWin'],
                        value: true,
                        description: 'The matched team is coming off a loss.',
                        sports: ['all'],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: true,
                        sidePreference: 'away',
                    },
                    lessPublicBetsSpread: {
                        homeMatched: false,
                        awayMatched: true,
                        category: 'general',
                        label: 'Less Public Bets (spread)',
                        id: 'lessPublicBetsSpread',
                        type: 'boolean',
                        value: true,
                        description: 'The matched team will have less public bets on the spread.',
                        sports: ['all'],
                        disabledBy: [],
                        filterTargets: ['home', 'away'],
                        requiresLastGame: false,
                    },
                },
                description: 'with the current line favoring them more than the opener, coming off a loss, getting less public bets on the spread.',
                type: 'team',
                query: true,
                teamId: 234345,
            },
        ],
        bookData: {
            moneylines: [
                {
                    awayLine: 164,
                    homeLine: -198,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: 162,
                    homeLine: -195,
                    label: 'Caesars',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-williamhill.png',
                    color: '#183432',
                },
                {
                    awayLine: 166,
                    homeLine: -198,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
            spreads: [
                {
                    awayLine: 4.5,
                    homeLine: -4.5,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: 4.5,
                    homeLine: -4.5,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: 4.5,
                    homeLine: -4.5,
                    label: 'Caesars',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-williamhill.png',
                    color: '#183432',
                },
                {
                    awayLine: 4.5,
                    homeLine: -4.5,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
        },
        openingSpread: 5.5,
        gameId: '2025-12-02T03-8922-234345',
        dateTime: '2025-12-02T03:00:00.000Z',
        totalStats: {
            total: 234.5,
            over: 4,
            under: 14,
        },
    },
    nfl: {
        awayTeam: {
            teamName: 'Tampa Bay',
            teamId: 4156,
            abbr: 'TAM',
            mascot: 'Buccaneers',
            teamName: 'Tampa Bay Buccaneers',
            shortName: 'TB',
            pitcherData: '',
            color: '#D50A0A',
            odds: {
                fullGame: {
                    moneyline: -185,
                    spread: -3.5,
                },
                half: {
                    spread: -2,
                    moneyline: -135,
                },
            },
            openMoneyLine: 120,
            spreadPercent: 53,
            mlPercent: 52,
            mlMoneyPercent: 72,
            spreadMoneyPercent: 67,
            injuries: [
                {
                    player: 'Antoine Winfield Jr.',
                    position: 'S',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Trey Palmer',
                    position: 'WR',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Jalen McMillan',
                    position: 'WR',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Calijah Kancey',
                    position: 'DT',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Luke Goedeke',
                    position: 'OT',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Cody Thompson',
                    position: 'WR',
                    date: 'Nov 10',
                    status: 'Out',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Markees Watts',
                    position: 'LB',
                    date: 'Nov 10',
                    status: 'Injured Reserve',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'SirVocea Dennis',
                    position: 'LB',
                    date: 'Nov 4',
                    status: 'Injured Reserve',
                    desc: 'Oct 4: Buccaneers head coach Todd Bowles said Friday that Allen (shoulder), who was placed on IR on Tuesday, will have his status evaluated week-to-week, Greg Auman of Fox Sports reports.',
                    value: 0,
                },
                {
                    player: 'Jordan Whitehead',
                    position: 'S',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: "Oct 3: Whitehead (groin) is questionable to return to Thursday's game against the Falcons, Brianna Dix of the Buccaneers' official site reports.",
                    value: 0,
                },
                {
                    player: 'Kameron Johnson',
                    position: 'WR',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: "Oct 3: Johnson (ankle) is questionable to return to Thursday's game against the Falcons, Scott Smith of the Buccaneers' official site reports.",
                    value: 0,
                },
                {
                    player: 'Evan Deckers',
                    position: 'LS',
                    date: 'Oct 27',
                    status: 'Injured Reserve',
                    desc: 'Sep 24: Deckers (hamstring) was placed on injured reserve Tuesday, Rick Stroud of the Tampa Bay Times reports.',
                    value: 0,
                },
                {
                    player: 'Bryce Hall',
                    position: 'CB',
                    date: 'Dec 1',
                    status: 'Injured Reserve',
                    desc: 'Sep 10: The Buccaneers placed Hall (ankle) on injured reserve Tuesday, Jenna Laine of ESPN.com reports.',
                    value: 0,
                },
                {
                    player: 'Earnest Brown IV',
                    position: 'DE',
                    date: 'Oct 13',
                    status: 'Injured Reserve',
                    desc: 'Sep 5: The Buccaneers placed Brown on the reserve/injured list Thursday due to a rib injury, Aaron Wilson of KPRC 2 Houston reports.',
                    value: 0,
                },
                {
                    player: 'Chase Edmonds',
                    position: 'RB',
                    date: 'Feb 10',
                    status: 'Injured Reserve',
                    desc: 'Aug 27: Edmonds was placed on season-ending injured reserve Monday due to a knee injury, Greg Auman of Fox Sports reports.',
                    value: 0,
                },
                {
                    player: 'Rakim Jarrett',
                    position: 'WR',
                    date: 'Oct 13',
                    status: 'Injured Reserve',
                    desc: 'Aug 26: Tampa Bay placed Jarrett (undisclosed) on its injured reserve list with a designation to return Monday, Greg Auman of Fox Sports reports.',
                    value: 0,
                },
                {
                    player: 'Silas Dzansi',
                    position: 'OT',
                    date: 'Feb 10',
                    status: 'Injured Reserve',
                    desc: "Aug 8: The Buccaneers placed Dzansi on injured reserve Thursday due to a knee injury, Scott Smith of the team's official site reports.",
                    value: 0,
                },
                {
                    player: 'Sua Opeta',
                    position: 'G',
                    date: 'Feb 10',
                    status: 'Injured Reserve',
                    desc: 'Aug 2: Tampa Bay placed Opeta on injured reserve Friday due to his torn ACL, Rick Stroud of the Tampa Bay Times reports.',
                    value: 0,
                },
            ],
            stats: {
                def: {
                    ppg: 22.8,
                    pypg: 258.4,
                    rypg: 119.8,
                    ypg: 378.2,
                },
                off: {
                    avgPenaltyYards: 33,
                    oppg: 25.4,
                    thirdDown: 44.83,
                    toRatio: 2,
                    top: 30,
                    oypg: 341.6,
                    opypg: 255.5,
                    orypg: 123.1,
                },
                splits: {},
            },
            averageMoneylines: {
                dog: {
                    avgML: 210,
                    totalGames: 2,
                },
                favorite: {
                    avgML: -235,
                    totalGames: 2,
                },
            },
            recordData: {
                ats: '3-2-0',
                awayRecord: '1-1',
                conferenceRecord: '3-1',
                divisionRecord: '0-1',
                homeRecord: '2-1',
                ou: '3-2-0',
                record: '3-2',
            },
            sos: 12,
            logo: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/nfl%2F4156_nfl.png?alt=media',
            division: 'South',
            conference: 'National Football Conference',
        },
        homeTeam: {
            teamName: 'New Orleans',
            teamId: 5437,
            abbr: 'NOR',
            mascot: 'Saints',
            teamName: 'New Orleans Saints',
            shortName: 'New Orleans',
            pitcherData: '',
            color: '#D3BC8D',
            odds: {
                fullGame: {
                    moneyline: 155,
                    spread: 3.5,
                },
                half: {
                    spread: 2,
                    moneyline: 115,
                },
            },
            openMoneyLine: -140,
            spreadPercent: 47,
            mlPercent: 48,
            mlMoneyPercent: 28,
            spreadMoneyPercent: 33,
            injuries: [
                {
                    player: 'Derek Carr',
                    position: 'QB',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: 'Oct 8: Carr will undergo an MRI on his left oblique Tuesday, Katherine Terrell of ESPN.com reports.',
                    value: 0,
                },
                {
                    player: 'Payton Turner',
                    position: 'DE',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Cesar Ruiz',
                    position: 'C',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Taysom Hill',
                    position: 'TE',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Willie Gay',
                    position: 'LB',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Will Harris',
                    position: 'CB',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: "Oct 7: Harris exited New Orleans' matchup versus the Chiefs on Monday due to an undisclosed injury, Jeff Nowak of Audacy Sports reports.",
                    value: 0,
                },
                {
                    player: 'Pete Werner',
                    position: 'LB',
                    date: 'Oct 13',
                    status: 'Questionable',
                    desc: "Oct 7: Werner (hamstring) is inactive ahead of Monday night's matchup against the Chiefs.",
                    value: 0,
                },
                {
                    player: 'Shane Lemieux',
                    position: 'C',
                    date: 'Nov 3',
                    status: 'Injured Reserve',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Kendre Miller',
                    position: 'RB',
                    date: 'Oct 13',
                    status: 'Injured Reserve',
                    desc: "Oct 7: Miller (hamstring) won't suit up Monday against the Chiefs, Ross Jackson of LouisianaSports.net reports.",
                    value: 0,
                },
                {
                    player: 'Erik McCoy',
                    position: 'C',
                    date: 'Oct 27',
                    status: 'Injured Reserve',
                    desc: 'Sep 25: McCoy (groin) was placed on injured reserve Wednesday, Ross Jackson of WWL Louisiana reports.',
                    value: 0,
                },
                {
                    player: 'Rejzohn Wright',
                    position: 'CB',
                    date: 'Feb 10',
                    status: 'Injured Reserve',
                    desc: 'Aug 29: Wright (undisclosed) was placed on injured reserve by the Saints on Tuesday.',
                    value: 0,
                },
                {
                    player: 'Nephi Sewell',
                    position: 'LB',
                    date: 'Oct 13',
                    status: 'Out',
                    desc: 'Aug 29: Sewell (knee) was placed on the reserve/PUP list by the Saints on Tuesday.',
                    value: 0,
                },
                {
                    player: 'Camron Peterson',
                    position: 'DT',
                    date: 'Feb 10',
                    status: 'Injured Reserve',
                    desc: 'Aug 28: Peterson (undisclosed) was placed on injured reserve by the Saints on Tuesday.',
                    value: 0,
                },
                {
                    player: 'Tanoh Kpassagnon',
                    position: 'DE',
                    date: 'Oct 13',
                    status: 'Out',
                    desc: 'Aug 27: Kpassagnon (Achilles) was placed on the reserve/PUP list by the Saints on Tuesday.',
                    value: 0,
                },
                {
                    player: 'Justin Herron',
                    position: 'OT',
                    date: 'Feb 10',
                    status: 'Injured Reserve',
                    desc: 'Jul 28: The Saints placed Herron on the injured reserve list Sunday due to a knee injury.',
                    value: 0,
                },
                {
                    player: 'Ryan Ramczyk',
                    position: 'OT',
                    date: 'Feb 10',
                    status: 'Out',
                    desc: 'Jul 18: The Saints placed Ramczyk (knee) on reserve/PUP Thursday, and he will miss the entirety of the 2024 season, Ian Rapoport of NFL Network reports.',
                    value: 0,
                },
            ],
            stats: {
                def: {
                    ppg: 19.2,
                    pypg: 251.2,
                    rypg: 105,
                    ypg: 356.2,
                },
                off: {
                    avgPenaltyYards: 58,
                    oppg: 28,
                    thirdDown: 50.88,
                    toRatio: 3,
                    top: 30,
                    oypg: 241.6,
                    opypg: 275.5,
                    orypg: 113.1,
                },
                splits: {},
            },
            averageMoneylines: {
                dog: {
                    avgML: 185,
                    totalGames: 3,
                },
                favorite: {
                    avgML: -170,
                    totalGames: 2,
                },
            },
            recordData: {
                ats: '3-2-0',
                awayRecord: '1-2',
                conferenceRecord: '2-2',
                divisionRecord: '1-1',
                homeRecord: '1-1',
                ou: '3-2-0',
                record: '2-3',
            },
            sos: 8,
            logo: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/nfl%2F5437_nfl.png?alt=media',
            division: 'South',
            conference: 'National Football Conference',
        },
        gameId: '2024-10-13T18:00:00.000Z-5437-4156',
        dateTime: '2024-10-13T18:00:00.000Z',
        status: 'not started',
        bookData: {
            moneylines: [
                {
                    awayLine: -200,
                    homeLine: 165,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: -175,
                    homeLine: 145,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: -186,
                    homeLine: 156,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
            spreads: [
                {
                    awayLine: -4,
                    homeLine: 4,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: -3.5,
                    homeLine: 3.5,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: -3.5,
                    homeLine: 3.5,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
        },
        openingSpread: 2.5,
        total: 41.5,
        totalStats: {
            total: 41.5,
            over: 3,
            under: 4,
        },
        advantages: [
            {
                adv: 'Key Factor - PPG',
                id: 'key-factor',
                factorId: 'oppg',
                winPercent: 50,
                teamId: 5437,
                description: 'NOR has a better PPG.  Teams with a better PPG win at a 50% rate.',
                amount: 2.6000000000000014,
            },
            {
                adv: 'Key Factor - DPPG',
                id: 'key-factor',
                factorId: 'ppg',
                winPercent: 48.333333333333336,
                teamId: 5437,
                description: 'NOR has a better DPPG.  Teams with a better DPPG win at a 48% rate.',
                amount: 3.6000000000000014,
            },
            {
                adv: 'Key Factor - YPG',
                id: 'key-factor',
                factorId: 'ypg',
                winPercent: 48.38709677419355,
                teamId: 4156,
                description: 'TAM has a better YPG.  Teams with a better YPG win at a 48% rate.',
                amount: 13.200000000000045,
            },
            {
                adv: 'Key Factor - toRatio',
                id: 'key-factor',
                factorId: 'toRatio',
                winPercent: 46.15384615384615,
                teamId: 5437,
                description: 'NOR has a better toRatio.  Teams with a better toRatio win at a 46% rate.',
                amount: 1,
            },
            {
                adv: 'Key Factor - 3rd Down',
                id: 'key-factor',
                factorId: 'thirdDown',
                winPercent: 48.38709677419355,
                teamId: 5437,
                description: 'NOR has a better 3rd Down.  Teams with a better 3rd Down win at a 48% rate.',
                amount: 6.050000000000004,
            },
            {
                adv: 'Key Factor - TOP',
                id: 'key-factor',
                factorId: 'top',
                winPercent: 51.66666666666667,
                teamId: 0,
                description: '',
                amount: 0,
            },
            {
                adv: 'Key Factor - Penalties',
                id: 'key-factor',
                factorId: 'avgPenaltyYards',
                winPercent: 55.73770491803278,
                teamId: 4156,
                description: 'TAM has a better Penalties.  Teams with a better Penalties win at a 55% rate.',
                amount: 25,
            },
            {
                adv: 'Key Factor - RYPG',
                id: 'key-factor',
                factorId: 'rypg',
                winPercent: 48.38709677419355,
                teamId: 5437,
                description: 'NOR has a better RYPG.  Teams with a better RYPG win at a 48% rate.',
                amount: 14.799999999999997,
            },
            {
                adv: 'Key Factor - PYPG',
                id: 'key-factor',
                factorId: 'pypg',
                winPercent: 46.774193548387096,
                teamId: 5437,
                description: 'NOR has a better PYPG.  Teams with a better PYPG win at a 46% rate.',
                amount: 7.199999999999989,
            },
            {
                adv: 'Power Rank',
                id: 'power-rank',
                description: 'NOR has an advantage based on our power rank data.',
                teamId: 5437,
                amount: 0,
            },
        ],
        prediction: {
            awayScore: 23.79,
            homeScore: 27.16,
            winner: 5437,
            spreadWinner: 5437,
            powerSpread: 3.370000000000001,
            powerMoneyline: {
                dogML: 169,
                favML: -179,
            },
            powerLineWinner: 5437,
            confidence: 0.75,
        },
        trends: [],
    },
    cfb: {
        awayTeam: {
            teamName: 'Clemson',
            teamId: 201,
            abbr: 'CLEM',
            mascot: '',
            teamName: 'Clemson Tigers',
            shortName: '',
            pitcherData: '',
            color: '#F56600',
            odds: {
                fullGame: {
                    spread: 11.5,
                    moneyline: 345,
                },
                half: {
                    spread: 6,
                    moneyline: 250,
                },
            },
            openMoneyLine: 315,
            spreadPercent: 45,
            mlPercent: 0,
            spreadMoneyPercent: 24,
            injuries: [
                {
                    player: 'T.                                                                                    Brown',
                    position: 'WR',
                    date: '',
                    status: 'Questionable',
                    desc: ' Ankle',
                },
                {
                    player: 'J.                                                                                    Haynes',
                    position: 'RB',
                    date: '',
                    status: 'Questionable',
                    desc: ' Leg',
                },
                {
                    player: 'K.                                                                                    McCloud',
                    position: 'LB',
                    date: '',
                    status: 'Out',
                    desc: ' Knee',
                },
                {
                    player: 'D.                                                                                    Pennington',
                    position: 'OL',
                    date: '',
                    status: 'Questionable',
                    desc: ' Undisclosed',
                },
                {
                    player: 'T.                                                                                    Howard',
                    position: 'OL',
                    date: '',
                    status: 'Out',
                    desc: ' Knee',
                },
                {
                    player: 'C.                                                                                    Gipson',
                    position: 'CB',
                    date: '',
                    status: 'Out',
                    desc: ' Undisclosed',
                },
                {
                    player: 'T.                                                                                    Stellato',
                    position: 'WR',
                    date: '',
                    status: 'Out',
                    desc: ' Thumb',
                },
                {
                    player: 'E.                                                                                    Thurmon',
                    position: 'OL',
                    date: '',
                    status: 'Out',
                    desc: ' Ankle',
                },
                {
                    player: 'C.                                                                                    Sadler',
                    position: 'OL',
                    date: '',
                    status: 'Out',
                    desc: ' Foot',
                },
                {
                    player: 'Q.                                                                                    Castner',
                    position: 'K/P',
                    date: '',
                    status: 'Out',
                    desc: ' Leg',
                },
            ],
            stats: {
                def: {
                    ppg: 22.3,
                    pypg: 214.4,
                    rypg: 150.5,
                    ypg: 364.9,
                },
                off: {
                    avgPenaltyYards: 46,
                    oppg: 34.3,
                    thirdDown: 45.16,
                    toRatio: 16,
                    top: 30,
                    oypg: 341.6,
                    opypg: 255.5,
                    orypg: 123.1,
                },
                splits: {},
            },
            averageMoneylines: {
                dog: {
                    avgML: 250,
                    totalGames: 2,
                },
                favorite: {
                    avgML: -911.6666666666666,
                    totalGames: 9,
                },
            },
            recordData: {
                ats: '6-7-0',
                awayRecord: '4-0',
                conferenceRecord: '7-1',
                divisionRecord: '0-0',
                homeRecord: '5-2',
                ou: '5-7-1',
                record: '10-3',
            },
            sos: 23,
            logo: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/cfb%2F201_cfb.svg?alt=media',
            rank: 13,
        },
        homeTeam: {
            teamName: 'Texas',
            teamId: 8458,
            abbr: 'UT',
            mascot: '',
            teamName: 'Texas Longhorns',
            shortName: 'TEX',
            pitcherData: '',
            color: '#bf5700',
            odds: {
                fullGame: {
                    spread: -11.5,
                    moneyline: -445,
                },
                half: {
                    spread: -6,
                    moneyline: -310,
                },
            },
            openMoneyLine: -410,
            spreadPercent: 54,
            mlPercent: 0,
            spreadMoneyPercent: 75,
            injuries: [
                {
                    player: 'K.                                                                                    Banks',
                    position: 'OL',
                    date: '',
                    status: 'Questionable',
                    desc: ' Undisclosed',
                },
                {
                    player: 'D.                                                                                    Williams',
                    position: 'DB',
                    date: '',
                    status: 'Out',
                    desc: ' Lower Body',
                },
                {
                    player: 'V.                                                                                    Gardner',
                    position: 'RB',
                    date: '',
                    status: 'Out',
                    desc: ' Undisclosed',
                },
                {
                    player: 'T.                                                                                    Owens',
                    position: 'QB',
                    date: '',
                    status: 'Out',
                    desc: ' Lower Body',
                },
                {
                    player: 'C.                                                                                    Clark',
                    position: 'RB',
                    date: '',
                    status: 'Out',
                    desc: ' Achilles',
                },
                {
                    player: 'C.                                                                                    Baxter',
                    position: 'RB',
                    date: '',
                    status: 'Out',
                    desc: ' Knee',
                },
            ],
            stats: {
                def: {
                    ppg: 12.5,
                    pypg: 143.1,
                    rypg: 106.7,
                    ypg: 249.8,
                },
                off: {
                    avgPenaltyYards: 53,
                    oppg: 33.6,
                    thirdDown: 42.61,
                    toRatio: 6,
                    top: 30,
                    oypg: 321.6,
                    opypg: 155.5,
                    orypg: 168.1,
                },
                splits: {},
            },
            averageMoneylines: {
                dog: {
                    avgML: 0,
                    totalGames: 0,
                },
                favorite: {
                    avgML: -595.9090909090909,
                    totalGames: 11,
                },
            },
            recordData: {
                ats: '7-6-0',
                awayRecord: '4-0',
                conferenceRecord: '7-1',
                divisionRecord: '0-0',
                homeRecord: '6-1',
                ou: '4-8-1',
                record: '11-2',
            },
            sos: 3,
            logo: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/cfb%2F8458_cfb.svg?alt=media',
            rank: 4,
        },
        gameId: '2024-12-21T22:00:00.000Z-8458-201',
        dateTime: '2024-12-21T22:00:00.000Z',
        status: 'not started',
        bookData: {
            moneylines: [],
            spreads: [],
        },
        openingSpread: 11,
        total: 56.5,
        totalStats: {
            total: 56.5,
            over: 30,
            under: 50,
        },
        advantages: [
            {
                adv: 'Key Factor - PPG',
                id: 'key-factor',
                factorId: 'oppg',
                winPercent: 52.47933884297521,
                teamId: 201,
                description: 'CLEM has a better PPG.  Teams with a better PPG win at a 52% rate.',
                amount: 0.6999999999999957,
            },
            {
                adv: 'Key Factor - DPPG',
                id: 'key-factor',
                factorId: 'ppg',
                winPercent: 51.031636863823934,
                teamId: 8458,
                description: 'UT has a better DPPG.  Teams with a better DPPG win at a 51% rate.',
                amount: 9.8,
            },
            {
                adv: 'Key Factor - YPG',
                id: 'key-factor',
                factorId: 'ypg',
                winPercent: 50.273972602739725,
                teamId: 201,
                description: 'CLEM has a better YPG.  Teams with a better YPG win at a 50% rate.',
                amount: 9.5,
            },
            {
                adv: 'Key Factor - toRatio',
                id: 'key-factor',
                factorId: 'toRatio',
                winPercent: 50.52316890881914,
                teamId: 201,
                description: 'CLEM has a better toRatio.  Teams with a better toRatio win at a 50% rate.',
                amount: 10,
            },
            {
                adv: 'Key Factor - 3rd Down',
                id: 'key-factor',
                factorId: 'thirdDown',
                winPercent: 50.824175824175825,
                teamId: 201,
                description: 'CLEM has a better 3rd Down.  Teams with a better 3rd Down win at a 50% rate.',
                amount: 2.549999999999997,
            },
            {
                adv: 'Key Factor - TOP',
                id: 'key-factor',
                factorId: 'top',
                winPercent: 48.503937007874015,
                teamId: 0,
                description: '',
                amount: 0,
            },
            {
                adv: 'Key Factor - Penalties',
                id: 'key-factor',
                factorId: 'avgPenaltyYards',
                winPercent: 51.38121546961326,
                teamId: 201,
                description: 'CLEM has a better Penalties.  Teams with a better Penalties win at a 51% rate.',
                amount: 7,
            },
            {
                adv: 'Key Factor - RYPG',
                id: 'key-factor',
                factorId: 'rypg',
                winPercent: 49.31318681318682,
                teamId: 8458,
                description: 'UT has a better RYPG.  Teams with a better RYPG win at a 49% rate.',
                amount: 43.8,
            },
            {
                adv: 'Key Factor - PYPG',
                id: 'key-factor',
                factorId: 'pypg',
                winPercent: 50.89163237311386,
                teamId: 8458,
                description: 'UT has a better PYPG.  Teams with a better PYPG win at a 50% rate.',
                amount: 71.30000000000001,
            },
            {
                adv: 'Power Rank',
                id: 'power-rank',
                description: 'CLEM has an advantage based on our power rank data.',
                teamId: 201,
                amount: 0,
            },
        ],
        prediction: {
            awayScore: 30.51,
            homeScore: 31.11,
            winner: 8458,
            spreadWinner: 201,
            powerSpread: 0.5999999999999979,
            powerMoneyline: {
                dogML: 117,
                favML: -117,
            },
            powerLineWinner: 201,
            confidence: 0.57,
        },
        trends: [],
    },
    cbb: {
        awayTeam: {
            teamName: 'Iowa State',
            teamId: 7606,
            abbr: 'ISU',
            mascot: '',
            teamName: 'Iowa State Cyclones',
            shortName: '',
            pitcherData: '',
            color: '#c8102e',
            odds: {
                fullGame: {
                    moneyline: 125,
                    spread: 2.5,
                },
            },
            openMoneyLine: -115,
            spreadPercent: 64,
            mlPercent: 15,
            mlMoneyPercent: 0,
            spreadMoneyPercent: 38,
            injuries: [
                {
                    player: 'M.                                                                                    Momcilovic',
                    position: 'F',
                    date: '',
                    status: 'Out',
                    desc: ' Hand',
                },
                {
                    player: 'C.                                                                                    Hawley',
                    position: 'F',
                    date: '',
                    status: 'Out',
                    desc: ' Shoulder',
                },
            ],
            stats: {
                def: {
                    defEff: 0.907,
                    fouls: 15.4,
                    oppThreePoint: 32.8,
                    ppg: 65.9,
                    reboundPercent: 37.4,
                },
                off: {
                    floorPercent: 55.5,
                    freeThrow: 75.4,
                    offEff: 1.164,
                    oppg: 84.6,
                    paceofplay: 81,
                    threePoint: 35,
                },
                splits: {},
            },
            averageMoneylines: {
                dog: {
                    avgML: 150,
                    totalGames: 2,
                },
                favorite: {
                    avgML: -818.3333333333334,
                    totalGames: 15,
                },
            },
            recordData: {
                ats: '13-6-0',
                awayRecord: '4-1',
                conferenceRecord: '7-1',
                divisionRecord: '0-0',
                homeRecord: '11-0',
                ou: '6-5',
                record: '17-2',
            },
            sos: 9,
            logo: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/cbb%2F7606_cfb.svg?alt=media',
        },
        homeTeam: {
            teamName: 'Arizona',
            teamId: 9257,
            abbr: 'ARIZ',
            mascot: '',
            teamName: 'Arizona Wildcats',
            shortName: '',
            pitcherData: '',
            color: '#CC0033',
            odds: {
                fullGame: {
                    moneyline: -145,
                    spread: -2.5,
                },
            },
            openMoneyLine: -105,
            spreadPercent: 36,
            mlPercent: 85,
            mlMoneyPercent: 96,
            spreadMoneyPercent: 62,
            injuries: [
                {
                    player: 'M.                                                                                    Krivas',
                    position: 'C',
                    date: '',
                    status: 'Out',
                    desc: ' Lower Leg',
                },
            ],
            stats: {
                def: {
                    defEff: 0.95,
                    fouls: 16.3,
                    oppThreePoint: 32.4,
                    ppg: 68.9,
                    reboundPercent: 39.8,
                },
                off: {
                    floorPercent: 54.4,
                    freeThrow: 75.2,
                    offEff: 1.14,
                    oppg: 82.7,
                    paceofplay: 86,
                    threePoint: 32.4,
                },
                splits: {},
            },
            averageMoneylines: {
                dog: {
                    avgML: 150,
                    totalGames: 2,
                },
                favorite: {
                    avgML: -1154.642857142857,
                    totalGames: 14,
                },
            },
            recordData: {
                ats: '10-9-0',
                awayRecord: '3-2',
                conferenceRecord: '7-1',
                divisionRecord: '0-0',
                homeRecord: '9-1',
                ou: '8-7',
                record: '13-6',
            },
            sos: 14,
            logo: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/cbb%2F9257_cfb.svg?alt=media',
        },
        gameId: '2025-01-28T04:30:00.000Z-9257-7606',
        dateTime: '2025-01-28T04:30:00.000Z',
        status: 'not started',
        bookData: {
            moneylines: [
                {
                    awayLine: 125,
                    homeLine: -155,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: 130,
                    homeLine: -155,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: 116,
                    homeLine: -142,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
            spreads: [
                {
                    awayLine: 2.5,
                    homeLine: -2.5,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: 3,
                    homeLine: -3,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: 2.5,
                    homeLine: -2.5,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
        },
        openingSpread: 1,
        total: 152.5,
        totalStats: {
            total: 152.5,
            over: 7,
            under: 10,
        },
        advantages: [
            {
                adv: 'Key Factor - PPG',
                id: 'key-factor',
                factorId: 'oppg',
                winPercent: 48.04031354983203,
                teamId: 7606,
                description: 'ISU has a better PPG.  Teams with a better PPG win at a 48% rate.',
                amount: 1.8999999999999915,
            },
            {
                adv: 'Key Factor - Floor',
                id: 'key-factor',
                factorId: 'floorPercent',
                winPercent: 49.012775842044135,
                teamId: 7606,
                description: 'ISU has a better Floor.  Teams with a better Floor win at a 49% rate.',
                amount: 1.1000000000000014,
            },
            {
                adv: 'Key Factor - oEff%',
                id: 'key-factor',
                factorId: 'offEff',
                winPercent: 47.649253731343286,
                teamId: 7606,
                description: 'ISU has a better oEff%.  Teams with a better oEff% win at a 47% rate.',
                amount: 0.02400000000000002,
            },
            {
                adv: 'Key Factor - 3 Point',
                id: 'key-factor',
                factorId: 'threePoint',
                winPercent: 46.531683539557555,
                teamId: 7606,
                description: 'ISU has a better 3 Point.  Teams with a better 3 Point win at a 46% rate.',
                amount: 2.6000000000000014,
            },
            {
                adv: 'Key Factor - FT',
                id: 'key-factor',
                factorId: 'freeThrow',
                winPercent: 49.325842696629216,
                teamId: 7606,
                description: 'ISU has a better FT.  Teams with a better FT win at a 49% rate.',
                amount: 0.20000000000000284,
            },
            {
                adv: 'Key Factor - Rebound',
                id: 'key-factor',
                factorId: 'reboundPercent',
                winPercent: 51.920744035584306,
                teamId: 9257,
                description: 'ARIZ has a better Rebound.  Teams with a better Rebound win at a 51% rate.',
                amount: 2.3999999999999986,
            },
            {
                adv: 'Key Factor - DPPG',
                id: 'key-factor',
                factorId: 'ppg',
                winPercent: 50.50580741850881,
                teamId: 7606,
                description: 'ISU has a better DPPG.  Teams with a better DPPG win at a 50% rate.',
                amount: 3,
            },
            {
                adv: 'Key Factor - dEff%',
                id: 'key-factor',
                factorId: 'defEff',
                winPercent: 49.30995897053339,
                teamId: 9257,
                description: 'ARIZ has a better dEff%.  Teams with a better dEff% win at a 49% rate.',
                amount: 0.04299999999999993,
            },
            {
                adv: 'Key Factor - Fouls PG',
                id: 'key-factor',
                factorId: 'fouls',
                winPercent: 49.77307110438729,
                teamId: 7606,
                description: 'ISU has a better Fouls PG.  Teams with a better Fouls PG win at a 49% rate.',
                amount: 0.9000000000000004,
            },
            {
                adv: 'Key Factor - 3 Point',
                id: 'key-factor',
                factorId: 'oppThreePoint',
                winPercent: 49.981252343457065,
                teamId: 9257,
                description: 'ARIZ has a better 3 Point.  Teams with a better 3 Point win at a 49% rate.',
                amount: 0.3999999999999986,
            },
            {
                adv: 'Power Rank',
                id: 'power-rank',
                description: 'ISU has an advantage based on our power rank data.',
                teamId: 7606,
                amount: 0,
            },
        ],
        prediction: {
            awayScore: 80.87,
            homeScore: 80.55,
            winner: 7606,
            spreadWinner: 7606,
            powerSpread: 0.3200000000000074,
            powerMoneyline: {
                dogML: 113,
                favML: -113,
            },
            powerLineWinner: 7606,
            confidence: 0.65,
        },
        trends: [],
    },
    nhl: {
        awayTeam: {
            teamName: 'Colorado',
            teamId: 8920312,
            abbr: 'COL',
            mascot: 'Avalanche',
            teamName: 'Colorado Avalanche',
            shortName: '',
            pitcherData: '',
            color: '#6F263D',
            odds: {
                fullGame: {
                    moneyline: -135,
                    spread: -1.5,
                },
            },
            openMoneyLine: -125,
            spreadPercent: 41,
            mlPercent: 76,
            mlMoneyPercent: 84,
            spreadMoneyPercent: 94,
            injuries: [
                {
                    player: 'Oliver Kylington',
                    position: 'D',
                    date: 'Dec 27',
                    status: 'Out',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Miles Wood',
                    position: 'LW',
                    date: 'Dec 31',
                    status: 'Injured Reserve',
                    desc: 'Dec 7: Wood (upper body) was placed on long-term injured reserve Saturday, per PuckPedia.',
                    value: 0,
                },
                {
                    player: 'Jonathan Drouin',
                    position: 'LW',
                    date: 'Dec 27',
                    status: 'Injured Reserve',
                    desc: 'Dec 7: Drouin (upper body) was placed on injured reserve retroactive to Nov. 23 on Saturday.',
                    value: 0,
                },
                {
                    player: 'Josh Manson',
                    position: 'D',
                    date: 'Dec 27',
                    status: 'Injured Reserve',
                    desc: 'Dec 2: Manson (upper body) was placed on injured reserve Monday, per the NHL media site.',
                    value: 0,
                },
                {
                    player: 'Tucker Poolman',
                    position: 'D',
                    date: 'Sep 15',
                    status: 'Injured Reserve',
                    desc: 'Oct 6: Colorado received Poolman (head) and a 2025 fourth-round draft pick from Vancouver on Sunday in exchange for Erik Brannstrom.',
                    value: 0,
                },
            ],
            stats: {
                def: {
                    hdsv: 74.4,
                    ppg: 3.03,
                    scsvPercent: 82.24,
                },
                off: {
                    oppg: 3.31,
                    pp: 23.96,
                    sog: 29.28,
                },
                splits: {},
            },
            averageMoneylines: {
                dog: {
                    avgML: 116.42857142857143,
                    totalGames: 7,
                },
                favorite: {
                    avgML: -178.75,
                    totalGames: 24,
                },
            },
            recordData: {
                awayRecord: '10-6-0',
                conferenceRecord: '0-0',
                divisionRecord: '0-0',
                homeRecord: '8-8-0',
                ou: '12-5-0',
                record: '5-14-0',
            },
            sos: 0,
            logo: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/nhl%2F8920312_nhl.svg?alt=media',
            division: 'Central',
            conference: 'Western Conference',
        },
        homeTeam: {
            teamName: 'Vancouver',
            teamId: 931231,
            abbr: 'VAN',
            mascot: 'Canucks',
            teamName: 'Vancouver Canucks',
            shortName: '',
            pitcherData: '',
            color: '#00205B',
            odds: {
                fullGame: {
                    moneyline: 115,
                    spread: 1.5,
                },
            },
            openMoneyLine: 105,
            spreadPercent: 59,
            mlPercent: 24,
            mlMoneyPercent: 16,
            spreadMoneyPercent: 0,
            injuries: [
                {
                    player: 'Kevin Lankinen',
                    position: 'G',
                    date: 'Dec 16',
                    status: 'Day-To-Day',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Derek Forbort',
                    position: 'D',
                    date: 'Dec 16',
                    status: 'Day-To-Day',
                    desc: '',
                    value: 0,
                },
                {
                    player: 'Filip Hronek',
                    position: 'D',
                    date: 'Jan 29',
                    status: 'Injured Reserve',
                    desc: 'Dec 5: Hronek (lower body) was placed on long-term injured reserve Thursday, retroactive to Nov. 27.',
                    value: 0,
                },
            ],
            stats: {
                def: {
                    hdsv: 81.69,
                    ppg: 3,
                    scsvPercent: 82.56,
                },
                off: {
                    oppg: 3.21,
                    pp: 23.81,
                    sog: 26.21,
                },
                splits: {},
            },
            averageMoneylines: {
                dog: {
                    avgML: 120.83333333333333,
                    totalGames: 6,
                },
                favorite: {
                    avgML: -169.75,
                    totalGames: 20,
                },
            },
            recordData: {
                awayRecord: '10-2-1',
                conferenceRecord: '0-0',
                divisionRecord: '0-0',
                homeRecord: '5-7-4',
                ou: '16-11-2',
                record: '15-9-5',
            },
            sos: 0,
            logo: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/nhl%2F931231_nhl.svg?alt=media',
            division: 'Pacific',
            conference: 'Western Conference',
        },
        gameId: '2024-12-17T04:30:00.000Z-931231-8920312',
        dateTime: '2024-12-17T04:30:00.000Z',
        status: 'not started',
        bookData: {
            moneylines: [
                {
                    awayLine: -135,
                    homeLine: 115,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: -135,
                    homeLine: 114,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: -140,
                    homeLine: 116,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
            spreads: [
                {
                    awayLine: -1.5,
                    homeLine: 1.5,
                    label: 'Bet MGM',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-betmgm.png',
                    color: '#ae996a',
                },
                {
                    awayLine: -1.5,
                    homeLine: 1.5,
                    label: 'DraftKings',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-draftkings.png',
                    color: '#62af23',
                },
                {
                    awayLine: -1.5,
                    homeLine: 1.5,
                    label: 'FanDuel',
                    logo: 'https://bctn-sao.s3.amazonaws.com/img/sportsbooks/icn-fanduel.png',
                    color: '#2192f5',
                },
            ],
        },
        openingSpread: 1.5,
        total: 6,
        totalStats: {
            total: 6,
            over: 105,
            under: 99,
        },
        advantages: [
            {
                adv: 'Key Factor - PPG',
                id: 'key-factor',
                factorId: 'oppg',
                winPercent: 55.98194130925508,
                teamId: 8920312,
                description: 'COL has a better PPG.  Teams with a better PPG win at a 55% rate.',
                amount: 0.10000000000000009,
            },
            {
                adv: 'Key Factor - DPPG',
                id: 'key-factor',
                factorId: 'ppg',
                winPercent: 52.144469525959366,
                teamId: 931231,
                description: 'VAN has a better DPPG.  Teams with a better DPPG win at a 52% rate.',
                amount: 0.029999999999999805,
            },
            {
                adv: 'Key Factor - SOG/G',
                id: 'key-factor',
                factorId: 'sog',
                winPercent: 54.95495495495496,
                teamId: 8920312,
                description: 'COL has a better SOG/G.  Teams with a better SOG/G win at a 54% rate.',
                amount: 3.0700000000000003,
            },
            {
                adv: 'Key Factor - PP',
                id: 'key-factor',
                factorId: 'pp',
                winPercent: 52.71493212669684,
                teamId: 8920312,
                description: 'COL has a better PP.  Teams with a better PP win at a 52% rate.',
                amount: 0.15000000000000213,
            },
            {
                adv: 'Key Factor - SCSV%',
                id: 'key-factor',
                factorId: 'scsvPercent',
                winPercent: 50.989010989010985,
                teamId: 931231,
                description: 'VAN has a better SCSV%.  Teams with a better SCSV% win at a 50% rate.',
                amount: 0.3200000000000074,
            },
            {
                adv: 'Key Factor - HDSV%',
                id: 'key-factor',
                factorId: 'hdsv',
                winPercent: 48.55875831485588,
                teamId: 931231,
                description: 'VAN has a better HDSV%.  Teams with a better HDSV% win at a 48% rate.',
                amount: 7.289999999999992,
            },
            {
                adv: 'Power Rank',
                id: 'power-rank',
                description: 'VAN has an advantage based on our power rank data.',
                teamId: 931231,
                amount: 5,
            },
        ],
        prediction: {
            awayScore: 2.62,
            homeScore: 3.52,
            winner: 931231,
            spreadWinner: 931231,
            powerSpread: 0.8999999999999999,
            powerMoneyline: {
                dogML: 120,
                favML: -120,
            },
            powerLineWinner: 931231,
            confidence: 0.65,
        },
        tremds: [],
    },
};
